import { request } from '@/api/httpClient'

export async function testListSandboxes() {
  return request({
    method: 'test/ListSandboxes'
  })
}

export async function testCreateTestJob(customerId) {
  return request({
    method: 'test/CreateTestJob',
    payload: { customerId }
  })
}
